module.exports = __webpack_public_path__ + "static/media/gameworks.2a8c94d8.jpg";